module.exports = __webpack_public_path__ + "img/play 2.2e7a66e3.svg";